import React from 'react';
import { useEffect, useState } from "react";
import "../../styles/support/contact_us.css";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import FeedbackThanks from "./feedback_thanks";
import { doc, getDoc, serverTimestamp, setDoc, updateDoc } from "firebase/firestore";

const ContactUs = () => {
    const navigate = useNavigate();
    const [getUserId, setUserId] = useState("");
    const [getUserEmail, setUserEmail] = useState("");
    const [getMessage, setMessage] = useState("");
    const [getThanksShow, setThanksShow] = useState(false);

    const onChangeMessage = (message) => {
        setMessage(message.target.value);
    };

    const onSendFeedBack = async (event) => {
        event.preventDefault(); 
        const userRef = doc(firebaseFirestore, "User Feedback", getUserId);
        const userDoc = await getDoc(userRef);
        const feedbackDetails = {
            email: getUserEmail,
            message: getMessage,
            date: serverTimestamp(),
        };

        if (userDoc.exists()) {
            await updateDoc(
                userRef, 
                {
                    [`feedback${Date.now().toString()}`]: feedbackDetails,
                }, 
                {merge: true}
            )
        }else{
            await setDoc(
                userRef, 
                {
                    [`feedback${Date.now().toString()}`]: feedbackDetails,
                }, 
                {merge: true}
            );
        }

        setThanksShow(true);
    }

    const goBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                setUserId(user.uid);
                setUserEmail(user.email);
            };
        });
    }, []);

    return(
        <div className="contact_us_screen">
            <div className="contact_us_screen_header_con">
                <p className="contact_us_screen_header">Share Your Feedback <span role='img' aria-label="smiling face">😊</span></p>
                <p onClick={goBack} className="home_view_discussions_back">back</p>
            </div>

            <div className="contact_us_screen_divider"></div>
            
            <form id="contact_us_form" className="contact_us_form" onSubmit={onSendFeedBack}>
                <p className="contact_us_screen_label">Message</p>
                <div className="contact_us_screen_input_con">
                    <textarea name="message" className="contact_us_screen_input" rows={7} placeholder="Enter your feedback..." type="text" value={getMessage} onChange={onChangeMessage} required />
                </div>

                <input className="contact_us_screen_button" type="submit" value={"Send Feedback"} />
            </form>
            {getThanksShow && <FeedbackThanks getShow={getThanksShow} setShow={setThanksShow} />}
        </div>
    );
};

export default ContactUs;